@let menuItems = menuItems$ | async;
@if (hasAccess() && menuItems && menuItems.length > 0) {
  <nav>
    <p-megamenu
      [model]="menuItems"
      styleClass="pssr-megamenu"></p-megamenu>
  </nav>
}
